module.exports = __webpack_public_path__ + "static/media/Mallards-Pond-Maintenance-Chart.66f45edf.pdf";